<template>
    <div class="contain">
        <img class="imgs" src="../../../assets/c19/guide00.png" alt="신규 입고 병원용 자외선차단제 신규 입고 안내 제로이드 더마 쉴드 크림 MD / SFP 50+, PH++++" />
        <img class="imgs" src="../../../assets/c19/guide01.png" alt="솔닥 보습제 MD 비대면 진료 안내(다음 내용 참조)" />
        <img class="imgs" src="../../../assets/c19/guide02.png" alt="솔닥 보습제 MD 비대면 진료 안내(다음 내용 참조)" />
        <img class="imgs" src="../../../assets/c19/guide03.png" alt="솔닥 보습제 MD 비대면 진료 안내(다음 내용 참조)" />
        <img class="imgs" src="../../../assets/c19/guide04.png" alt="솔닥 보습제 MD 비대면 진료 안내(다음 내용 참조)" />
        <img class="imgs" src="../../../assets/c19/guide05.png" alt="솔닥 보습제 MD 비대면 진료 안내(다음 내용 참조)" />
        <img class="imgs" src="../../../assets/c19/guide06.png" alt="솔닥 보습제 MD 비대면 진료 안내(다음 내용 참조)" />
        <img class="imgs" src="../../../assets/melanon_05.jpg" alt="" />
        <div class="sr-only">
            <h2>보습제 MD 비대면 진료로 간편하게</h2>
            <p>솔닥 앱을 통해 보습제 처방부터 배송, 서류발급까지 한 번에 해결하세요</p>
            <span>왜 솔닥을 선택해야 할까요?</span>
            <h3>숫자가 증명하는 압도적인 1등 역시 솔닥입니다</h3>
            <ul>
                <li>
                    구글 플레이스토어 건강/운동 부문
                    <strong>1위</strong>
                </li>
                <li>
                    애플 앱스토어 건강 부문
                    <strong>2위</strong>
                </li>
                <li>
                    한국경제 비대면진료 소비자만족지수
                    <strong>1위</strong>
                </li>
                <li>
                    2023년 보건복지부
                    <strong>장관상 수상</strong>
                </li>
                <li>
                    솔닥 소비자만족지수(NPS)
                    <strong>93점</strong>
                </li>
                <li>
                    앱 스토어 평점
                    <strong>4.9점</strong>
                </li>
            </ul>
            <h3>앱으로 더욱 간편하게 진료받고 서류 발급까지 가능해요</h3>
            <p>솔닥 앱을 통해 간편한 진료 예약을 경험해 보세요! 진료 후 앱으로 서류 발급 및 조회가 가능해요</p>
            <h3>서비스 이용 수수료는 없어요</h3>
            <p>진료비, 약제비 외 이용 수수료가 없어 비용 부담없이 사용할 수 있어요</p>
            <h3>보습제가 문 앞까지 안전하게 배송돼요</h3>
            <p>병원에 재고 문의할 필요없이 편하고 안전하게 배송받을 수 있어요.</p>
            <p>* 서울 전역 및 경기, 인천 일부 지역 당일 배송 가능 (오후 1시 이전 결제 시, 자세한 사항은 하단 FAQ 확인)</p>
            <h3>비대면진료는 영상/음성 통화로 진행돼요</h3>
            <p>상황에 따라 영상통화가 불가능한 경우에는 음성통화로 비대면진료를 진행할 수 있어요</p>
            <h3>솔닥에서 처방 가능한 보습제를 확인하세요</h3>
            <ul>
                <li>
                    <strong>제로이드</strong>
                    <ul>
                        <li>인텐시브 리치 MD 크림</li>
                        <li>인텐시브 MD 크림</li>
                        <li>인텐시브 MD 로션</li>
                        <li>루트힐 모이스처라이저 MD</li>
                        <li>써지엔젤 플러스 MD</li>
                        <li>더마 쉴드 크림 MD</li>
                    </ul>
                </li>
                <li>
                    <strong>에스트라</strong>
                    <ul>
                        <li>아토베리어 MD 크림</li>
                        <li>아토베리어 MD 로션</li>
                        <li>에스트라 MD 크림</li>
                        <li>아토베리어 잇칭 크림 MD</li>
                        <li>더마베이비 PRO 크림 MD</li>
                        <li>더마베이비 PRO 로션 MD</li>
                        <li>아토베리어 AI MD 크림</li>
                    </ul>
                </li>
                <li>
                    <strong>셀퓨전씨</strong>
                    <ul>
                        <li>엑스퍼트 배리덤 로션 MD</li>
                        <li>엑스퍼트 배리덤 크림 MD</li>
                        <li>엑스퍼트 배리덤 쉴드크림 MD</li>
                    </ul>
                </li>
                <li>
                    <strong>이지듀</strong>
                    <ul>
                        <li>이지듀 MD 크림</li>
                        <li>이지듀 MD 로션</li>
                        <li>이지듀 MD 리젠 크림</li>
                    </ul>
                </li>
                <li>
                    <strong>그외</strong>
                    <ul>
                        <li>리쥬더마 아토 크림 MD</li>
                        <li>덱세릴 MD 크림</li>
                    </ul>
                </li>
            </ul>
            <h3>FAQ 자주 묻는 질문</h3>
            <p>보습제 MD 등 병원 판매 의료기기의 경우, 택배 배송 및 수령이 가능합니다.</p>
            <h4>보습제 수령(배송)에 대한 질문</h4>
            <div>
                <dl>
                    <dt>배송 가능 지역이 어떻게 되나요?</dt>
                    <dd>솔닥은 전국 어디든 배송이 가능합니다.</dd>
                </dl>
                <dl>
                    <dt>당일 배송이 가능한 지역은 어디인가요?</dt>
                    <dd>서울 전역과 인천, 경기 일부 지역은 평일 오후 1시 이전 결제 시 당일 배송이 가능합니다.</dd>
                </dl>
                <dl>
                    <dt>전 지역 서비스 가능 지역</dt>
                    <dd>서울, 성남, 부천, 안양, 과천, 수원, 구리, 의왕, 군포</dd>
                </dl>
                <dl>
                    <dt>일부 지역 서비스 가능 지역</dt>
                    <dd>
                        <ul>
                            <li>인천시 : 부평구/계양구/미추홀구/남동구 간석동, 만석동, 구월동</li>
                            <li>고양시 : 일산 서구/일산 동구/덕양구 화정동, 행신동, 강매동, 덕은동, 도내동, 동산동, 삼송동, 성사동, 주교동, 지축동, 토당동, 행주내동, 행주외동</li>
                            <li>광명시 : 광명1~5동, 철산1~4동, 하안2~4동, 소하1~2동, 일직동</li>
                            <li>남양주시 : 다산동, 별내동</li>
                            <li>안산시 : 상록구/단원구 고잔동, 목내동, 선부동, 성곡동, 신길동, 와동, 원곡동, 원시동, 초지동</li>
                            <li>용인시 : 수지구</li>
                            <li>하남시 : 선동, 만월동, 감일동, 감이동, 학암동</li>
                            <li>화성시 : 능동, 반송동, 석우동, 영천동, 오산동, 청계동</li>
                        </ul>
                    </dd>
                </dl>
                <dl>
                    <dt>당일 배송 방법</dt>
                    <dd>
                        <ol>
                            <li>1. 월-목 오후 1시 이전 진료와 결제를 마무리해주세요</li>
                            <li>2. 수령 방법으로 '택배 수령'을 선택해주세요</li>
                            <li>3. 보습제가 당일 밤 10시까지 도착합니다</li>
                        </ol>
                    </dd>
                </dl>
            </div>
            <h4>비대면 진료 이용에 대한 질문</h4>
            <div>
                <dl>
                    <dt>비대면진료는 어떻게 보나요?</dt>
                    <dd>솔닥 앱을 통해 비대면 진료를 이용하실 수 있습니다. 솔닥 앱을 다운로드한 후, 간편하게 진료 예약을 할 수 있습니다. 
                        진료는 환자가 선택한 영상통화 또는 음성통화 방식으로 진행되며 처방약은 솔닥 앱을 통해 원하는 방법으로 수령할 수 있습니다.
                    </dd>
                </dl>
                <dl>
                    <dt>비대면진료 후 처방약은 어떻게 수령하나요?</dt>
                    <dd>처방약은 가까운 약국에서 픽업할 수 있습니다. 진료 후, 앱을 통해 인근 약국을 선택하고 처방전을 전송하세요.
                        선택한 약국에 방문하여 처방약을 수령하세요. 보습제MD 등 병원 판매 의료기기의 경우, 택배 수령이 가능합니다.
                    </dd>
                </dl>
            </div>
        </div>
		<a href="https://soldoc.ap2.dfn.link/api/v1/click/HhtVmI6w9Ua1E6cVZyZcxA?adv_campaign=barosoldoc&adv_ad=soldocweb_%EC%97%B4%EB%82%98%EC%9A%94&adv_adgroup=web&adv_creative=%EC%97%B4%EB%82%98%EC%9A%94_240416&abx_tracker_id=HhtVmI6w9Ua1E6cVZyZcxA" class="c19-floot-cta" target="_blank" title="새 창 열림">			
			<img class="imgs" src="../../../assets/c19/img-cta-btn.png" alt="" />
		</a>
    </div>
</template>

<script>
export default {
	name: "c19",
	methods: {}
};
</script>

<style scoped>
.contain {
	width: 100%;
	position: relative;
	display: flex;
	justify-content: flex-start;
	align-items: center;
	flex-direction: column;
}
.imgs {
	width: 100%;
}
.contain .sr-only {
	position: absolute;
	left: -9999px;
	width: 1px;
	height: 1px;
	margin: 0 !important;
	font-size: 0;
	line-height: 0;
	overflow: hidden;
}
.c19-floot-cta{
	position: fixed;
	bottom: 15px;
	width: auto;
	padding: 0 33px;
	max-width: 100%;
	z-index: 10;
	cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/mobile_view/contents/c19.vue